var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnchorArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 29,
    viewBox: "0 0 53 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1279 5.16893C27.2526 4.20739 25.7474 4.20739 24.8721 5.16893L3.83623 28.2788C3.01209 29.1842 1.61517 29.2454 0.716121 28.4154C-0.182933 27.5855 -0.243669 26.1788 0.580464 25.2734L21.6164 2.16346C24.2421 -0.721151 28.7579 -0.721154 31.3836 2.16346L52.4195 25.2734C53.2437 26.1788 53.1829 27.5855 52.2839 28.4154C51.3848 29.2454 49.9879 29.1842 49.1638 28.2788L28.1279 5.16893Z",
    fill: "url(#paint0_linear_1924_311)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1924_311",
    x1: 26.5,
    y1: 0.0894326,
    x2: 26,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363277,
    stopColor: "#31569C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DE49C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorArrow2);
export default __webpack_public_path__ + "static/media/anchorArrow2.43e3858d4758700c542724f53efc5671.svg";
export { ForwardRef as ReactComponent };